var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:`wc-payment-badge__${_vm.paymentOption.id}`,staticClass:"badge wc-payment-badge p-2 text-truncate font-size-2xs font-weight-normal"},[_vm._v(" "+_vm._s(_vm.paymentOption.name)+" "),_c('WCToolTip',{attrs:{"target":`wc-payment-badge__${_vm.paymentOption.id}`}},[_vm._v(" "+_vm._s(_vm.paymentOption.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }